module.exports = __webpack_public_path__ + "static/img/image_shangwu.967beab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homePage/image_shangwu.png
// module id = TWsr
// module chunks = 1